export const PATHS = {
  ROOT: '/',
  ACCOUNT_PROFILE: '/profile',
  WELCOME: '/welcome'
};
